export const GEOIDS = [
  'GEOID03',
  'GEOID06',
  'GEOID09',
  'GEOID12B',
  'GEOID18',
  'GEOID96',
  'GEOID99',
];

export const SHARE_LINK_TOKEN_HEADER = 'skand-share-link-token';

export const COLOR_FROM_FIELD_CUSTOM = 'COLOR_FROM_FIELD_CUSTOM';
